(() => {
  const COMPONENT_SELECTOR = 'shop-follow-button';
  const STYLE_ID = 'crux-aura-shop-follow-state-fix';
  const FOLLOWING_ATTRIBUTE = 'data-crux-following';

  const shadowStyles = `
    :host {
      --crux-shop-follow-text: rgb(251 247 252);
      --crux-shop-follow-active-bg: rgb(115 88 200 / 0.28);
      --crux-shop-follow-active-border: rgb(251 247 252 / 0.34);
    }

    button,
    button span,
    button svg {
      color: var(--crux-shop-follow-text) !important;
    }

    :host([${FOLLOWING_ATTRIBUTE}]) button {
      min-height: 36px;
      padding-inline: 12px !important;
      border: 1px solid var(--crux-shop-follow-active-border) !important;
      border-radius: 999px !important;
      background: var(--crux-shop-follow-active-bg) !important;
    }

    :host([${FOLLOWING_ATTRIBUTE}]) button:hover {
      background: rgb(115 88 200 / 0.42) !important;
    }

    :host([${FOLLOWING_ATTRIBUTE}]) button:focus-visible {
      outline: 2px solid var(--crux-shop-follow-text) !important;
      outline-offset: 3px !important;
    }
  `;

  const syncComponent = (component) => {
    const shadowRoot = component.shadowRoot;
    if (!shadowRoot) return false;

    const inheritedColor = getComputedStyle(component).color;
    if (inheritedColor) {
      component.style.setProperty('--crux-shop-follow-text', inheritedColor);
    }

    let style = shadowRoot.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = shadowStyles;
      shadowRoot.append(style);
    }

    const isFollowing = /following\s+on\s+shop/i.test(shadowRoot.textContent || '');
    component.toggleAttribute(FOLLOWING_ATTRIBUTE, isFollowing);

    if (!component.__cruxShopFollowObserver) {
      const shadowObserver = new MutationObserver(() => syncComponent(component));
      shadowObserver.observe(shadowRoot, { childList: true, subtree: true, characterData: true });
      component.__cruxShopFollowObserver = shadowObserver;
    }

    return true;
  };

  const syncAll = () => {
    document.querySelectorAll(COMPONENT_SELECTOR).forEach((component) => {
      if (syncComponent(component)) return;

      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (syncComponent(component) || attempts >= 40) window.clearInterval(timer);
      }, 125);
    });
  };

  const pageObserver = new MutationObserver(syncAll);

  const start = () => {
    syncAll();
    pageObserver.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
